import { render, staticRenderFns } from "./yiPurple.vue?vue&type=template&id=6c6c6dbb&scoped=true&"
import script from "./yiPurple.vue?vue&type=script&lang=js&"
export * from "./yiPurple.vue?vue&type=script&lang=js&"
import style0 from "./yiPurple.vue?vue&type=style&index=0&id=6c6c6dbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c6dbb",
  null
  
)

export default component.exports